import * as React from 'react';
import { Grid, Header } from 'semantic-ui-react';

import EntityTableFieldRender from './components/EntityTableFieldRender';

export default class NotificationsForm extends React.PureComponent {
    render(): React.ReactElement {
        return (
            <Grid>
                <Grid.Column width={16}>
                    <Header as="h3">Notifications</Header>
                </Grid.Column>
                <Grid.Column width={16}>Harvest event updates</Grid.Column>
                <Grid.Column width={16}>
                    <EntityTableFieldRender />
                </Grid.Column>
            </Grid>
        );
    }
}
